<template>
	<transition>
		<div ref="mask" class="alert-mask">
			<div ref="wrapper" class="alert-wrapper" @click="clickOnMask">
				<div class="alert-container">
					<div class="close" v-show="showClose" @click="$emit('close')">&times;</div>
					<slot></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props: { showClose: { type: Boolean, default: true } },
	data: function() {
		return {}
	},
	methods: {
		clickOnMask(event) {
			if (event.target.classList.contains('alert-wrapper')) {
				this.$emit('close')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.alert-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
	.alert-wrapper {
		display: table-cell;
		vertical-align: middle;
		.alert-container {
			width: 300px;
			margin: 0px auto;
			padding: 0px 0px;
			background-color: #fff;
			border: #fdb947 2px solid;
			border-radius: 10px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
			transition: all 0.3s ease;
			font-family: Helvetica, Arial, sans-serif;
			.close {
				background-color: white;
				border-radius: 50%;
				height: 30px;
				width: 30px;
				font-weight: 800;
				color: #646979;
				font-size: 22px;
				float: right;
				text-align: center;
				margin-top: -20px;
				margin-right: -10px;
			}
		}
	}
}

</style>